import { useContext, useEffect } from 'react';

import { ToastComponent } from '../../components/ToastComponent';
import {
  GET_REASSIGNMENT,
  GET_REASSIGNMENT_SUCCESS,
  GET_REASSIGNMENT_ERROR,
  PATCH_REASSIGNMENT,
  PATCH_REASSIGNMENT_ERROR,
  PATCH_REASSIGNMENT_SUCCESS,
} from '../../constants/reassignment';
import { getCurrentPosition, ICoordinates } from '../../utils/utils';
import { StoreContext } from '../../context/Provider';
import useApi from '../../services/request.service';
import { locationPermissionService } from '../../services/locationPermissionService';

type ReassignmentType = 'SAM' | 'Device';

export const useReassigment = () => {
  const { getReassignmentSAMState, patchReassignmentState } =
    useContext(StoreContext);
  const { genericApiCallApiBilling } = useApi();

  const getReassignment = async (_type: ReassignmentType = 'SAM') => {
    const currentStatus = locationPermissionService.getPermissionStatus();
    if (currentStatus !== 'granted') {
      ToastComponent(
        'warning',
        'Error',
        'Por favor activa la ubicación para continuar.',
        6000
      );
      return;
    }

    let coords: ICoordinates =
      await locationPermissionService.getCurrentCoordinates();
    const data = {
      searchType: _type === 'SAM' ? 1 : 2,
    };

    const dispatch = getReassignmentSAMState.dispatch;

    dispatch({ type: GET_REASSIGNMENT });

    try {
      const result: any = await genericApiCallApiBilling(
        '/v1.0/inventory/not-assigned',
        'GET',
        {},
        { searchType: data.searchType },
        {
          appId: 'web',
          locationGPS: `${coords?.latitude}, ${coords?.longitude}`,
        }
      );
      if (result.status === 200) {
        const payload = result.data;
        dispatch({
          type: GET_REASSIGNMENT_SUCCESS,
          payload: payload,
        });
      }
      return result;
    } catch (error: any) {
      ToastComponent(
        'warning',
        'Error',
        'La operación falló, inténtelo más tarde por favor.'
      );
      dispatch({
        type: GET_REASSIGNMENT_ERROR,
        payload: error.message,
      });
      return 'error';
    }
  };

  const patchReassignment = async (data: any, samId: number) => {
    const dispatch = patchReassignmentState.dispatch;
    try {
      const currentStatus = locationPermissionService.getPermissionStatus();
      if (currentStatus !== 'granted') {
        ToastComponent(
          'warning',
          'Error',
          'Por favor activa la ubicación para continuar.',
          6000
        );
        return;
      }

      dispatch({ type: PATCH_REASSIGNMENT });
      let coords: ICoordinates =
        await locationPermissionService.getCurrentCoordinates();
      const result: any = await genericApiCallApiBilling(
        '/v1.0/sam-inventory/reassign/' + samId,
        'PATCH',
        data,
        {},
        {
          locationGPS: `${coords.latitude}, ${coords.latitude}`,
          appId: 'web',
        }
      );
      if (result.status === 200) {
        ToastComponent('success', '', 'Actualizado correctamente');
        const payload = result.data.payload;
        dispatch({
          type: PATCH_REASSIGNMENT_SUCCESS,
          payload: payload,
        });
      }
      return result;
    } catch (error: any) {
      ToastComponent('warning', '', error.message);

      dispatch({
        type: PATCH_REASSIGNMENT_ERROR,
        payload: error,
      });
      return 'error';
    }
  };

  return {
    getReassignment,
    patchReassignment,
  };
};
